import { UserLayout,PageLayout } from '@/layouts'
import TopoLayout from '@/layouts/TopoLayout.vue'
import { type Router } from './types'
import { example } from './exampleRouterMap'
import errorPage from '@/views/exception/500.vue'

// info:todo:1.如果使用服务端获取路由,path: '/',这块路由再写就会被覆盖
// 2.router.addRoute(parent, routeObj),添加parent,它就会自动加上/parent/xxx,直接写parent即可,就算嵌套多层也没事,自动变成/xxxx/xxxx/parent/xxxxx
// 3.以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;
// 在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
export default [
  // 示例用路由,可删
  {
    path:'/',
    name:'index',
    component:()=>import('@/views/Home.vue')
  },
  {
    path: '/user',
    name: 'user',
    component: UserLayout,
    redirect: '/login',
    children: [
      {
            path: '/login',
            name: 'login',
            component: () => import('@/views/user/Login.vue'),
            meta: { title: 'user.login.signup' },
      },
      {
                path: '/register',
                name: 'register',
                component: () => import('@/views/user/Register.vue'),
                meta: { title: 'user.login.signup' }
      },
      {
        path: 'registerResult',
        name: 'registerResult',
        component: () => import('@/views/user/RegisterResult.vue'),
        meta: { title: 'user.login.signup' }
      }
    ]
  },
  {
    path: '/500',
    name: 'error',
    component: errorPage,
  },
  {
    path: '/:path(.*)',
    name: 'NoMatch',
    component: () => import('@/views/exception/404.vue'),
  },
  {
    path:'/screen',
    name:'screen',
    component: () => import('@/views/screen/index.vue'),
  },
  {
    path:'/home',
    name:'home',
    redirect:'/pages',
    component:PageLayout,
    children:[
      {
        path:'/pages',
        name:'pages',
        component: () => import('@/views/pages.vue'),
        meta:{title:'自定义页面'}
      },
      {
        path:'/pageview',
        name:'pageview',
        component: () => import('@/views/pageview.vue'),
        meta:{title:'预览组件'}
      },

    ]
  },
  {
    path:'/topo',
    name:'topo',
    component:TopoLayout,
    redirect:'/topo/index',
    children:[
      {
        path:'/topo/index',
        name:'topoindex',
        component: () => import('@/views/topo/Editor.vue'),
        meta:{title:'组态'}
      },
      {
        path:'/topo/full',
        name:'topofull',
        component: () => import('@/views/topo/Fullscreen.vue'),
        meta:{title:'组态'}
      }
    ]
  },
  {
        path:'/pages3d',
        name:'pages3d',
        component: () => import('@/views/pages3d.vue'),
        meta:{title:'3d界面预览'}
  },
  {
    name:'scene3d',
    path:'/scene3d',
    component:() => import('@/views/scene/index.vue'),
    meta:{title:'menu.scene3d',icon: 'bx-analyse',}
  },
  {
    name:'editor3d',
    path:'/editor3d',
    component:() => import('@/views/scene/editor.vue'),
    meta:{title:'menu.editor3d',icon: 'bx-analyse',}
  },
  {
    name:'scaner3d',
    path:'/scaner3d',
    component:() => import('@/views/scene/scanner.vue'),
    meta:{title:'menu.scaner3d',icon: 'bx-analyse'}
  },
  {
    name:'hotcamara',
    path:'/hotcamara',
    component:() => import('@/views/scene/hotcamara.vue'),
    meta:{title:'menu.hotcamara',icon: 'bx-analyse'}
  },
  {
    name:'editor2d',
    path:'/editor2d',
    component:() => import('@/views/scene2d/editor.vue'),
    meta:{title:'menu.editor2d',icon: 'bx-analyse'}
  },
  {
    name:'scene2d',
    path:'/scene2d',
    component:() => import('@/views/scene2d/index.vue'),
    meta:{title:'menu.scene2d',icon: 'bx-analyse'}
  }

] as Router[]
